import { UserInput } from 'src/modules/user-input/types.ts';
import { TargetUnits } from 'src/modules/user-input/targetUnits.ts';

export const getInitialState = (targetUnits: TargetUnits): Readonly<UserInput> => ({
    kvs: '',
    kvs_u: targetUnits.volumetricFlow.name,
    kvs_2: '',
    kvs_2_u: targetUnits.volumetricFlow.name,
    v100: '',
    v100_u: targetUnits.volumetricFlow.name,
    v100_2: '',
    v100_2_u: targetUnits.volumetricFlow.name,
    dpmv: '',
    dpmv_u: targetUnits.dpmv.name,
    maxDp: '',
    maxDp_u: targetUnits.dpv100.name,
    maxDp_2: '',
    maxDp_2_u: targetUnits.dpv100.name,
    mass: '',
    mass_u: targetUnits.massVolumetricFlow.name,
    inlet: '',
    outlet: '',
    inlet_u: targetUnits.dpv100.name,
    outlet_u: targetUnits.dpv100.name,
});

export function initInputState(search: URLSearchParams, initialState: UserInput) {
    const value = search.get('input');
    if (value) {
        try {
            const parsed = JSON.parse(value);
            return (Object.keys(initialState) as Array<keyof UserInput>).reduce((acc, name) => {
                if (parsed[name] && typeof parsed[name] === 'string') {
                    acc[name] = parsed[name];
                }
                return acc;
            }, { ...initialState } as UserInput);
        } catch (e) {
            return { ...initialState };
        }
    }
    return { ...initialState };
}
